module.exports = __webpack_public_path__ + "static/media/ion.a246c4df.svg";